import Pusher from "pusher-js";
import { Action } from "@/interfaces/meeting/details";

export enum Roles {
  SALES_REP = "salesrep",
  CLIENT = "client"
}

export enum EventTypes {
  ACTION = "client-ACTION",
  FEEDBACK = "client-FEEDBACK",
  CHAT_MESSAGE = "client-CHAT_MESSAGE",
  RAISE_HAND = "client-RAISE_HAND",
  UNRAISE_HAND = "client-UNRAISE_HAND",
  HAND_RESET = "client-HAND_RESET",
  NAME_UPDATE = "client-NAME_UPDATE",
  UPDATE_CHAT = "client-UPDATE_CHAT",
  UPDATE_CART = "client-UPDATE_CART",
  SIGNATORY_CHANGED = "client-SIGNATORY_CHANGED",
  SIGNATURE_CHANGED = "client-SIGNATURE_CHANGED",
  TNC_ACCEPTED = "client-TNC_ACCEPTED",
  GIPT_FORM_CHANGED = "client-GIPT_FORM_CHANGED",
  GIPT_PACKAGES_CHANGED = "client-GIPT_PACKAGES_CHANGED",
  REPORT_AV_ISSUE = "client-REPORT_AV_ISSUE",
  ISSUE_RESET = "client-ISSUE_RESET",
  RETRACT_ISSUE_REPORT = "client-RETRACT_ISSUE_REPORT",
  MUTE = "client-MUTE",
  UNMUTE = "client-UNMUTE",
  END_MEETING = "client-END_MEETING"
}

export type EventType =
  | EventTypes.ACTION
  | EventTypes.CHAT_MESSAGE
  | EventTypes.FEEDBACK
  | EventTypes.RAISE_HAND
  | EventTypes.UNRAISE_HAND
  | EventTypes.HAND_RESET
  | EventTypes.NAME_UPDATE
  | EventTypes.UPDATE_CHAT
  | EventTypes.UPDATE_CART
  | EventTypes.SIGNATORY_CHANGED
  | EventTypes.SIGNATURE_CHANGED
  | EventTypes.TNC_ACCEPTED
  | EventTypes.GIPT_FORM_CHANGED
  | EventTypes.GIPT_PACKAGES_CHANGED
  | EventTypes.REPORT_AV_ISSUE
  | EventTypes.ISSUE_RESET
  | EventTypes.RETRACT_ISSUE_REPORT
  | EventTypes.MUTE
  | EventTypes.UNMUTE
  | EventTypes.END_MEETING;

export interface ActionChangeObserver {
  onActionChange: (action: Action) => void;
}

export type EventObserverMapping = { [key in EventType]?: Function };

export const setupObservers = (
  client: Pusher,
  mappings: EventObserverMapping
): void => {
  for (const kind in mappings) {
    const k = kind as EventType;
    client.bind(kind, mappings[k]!);
  }
};
